const productCardOptions = document.querySelectorAll("#product-grid .product-form__input");
productCardOptions.forEach(cardOption => {
  if(cardOption.classList.contains("color-swatch")) return;

  cardOption.querySelectorAll("input[type='radio']").forEach(cardOptionRadio => {
    cardOptionRadio.addEventListener("change", function(e){
      if(cardOptionRadio.closest(".quick-add") && cardOptionRadio.closest(".quick-add").querySelector("button[name='add']")) {
        setTimeout(function(){
          cardOptionRadio.closest(".grid__item").classList.remove("showed");
          cardOptionRadio.closest(".quick-add").querySelector("button[name='add']").click();
        }, 300);
      }
    })
  })
});

document.querySelectorAll("#product-grid .card-quick-option-label").forEach(optionToggler => {
  optionToggler.addEventListener("click", function(e){
    e.preventDefault();

    e.target.closest(".grid__item").classList.toggle("showed");
  })
})